import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container d-flex flex-column p-4" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "row d-grid gap-2 col-10 mx-auto mt-2" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      class: "img-fluid",
      src: `data:image/jpeg;base64,${$setup.document!.data}`
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        type: "button",
        onClick: $setup.accept,
        disabled: $setup.isLoadingDocument
      }, [
        ($setup.isLoadingDocument)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5))
          : _createCommentVNode("", true),
        _createTextVNode(_toDisplayString(_ctx.$t('actions.accept')), 1)
      ], 8, _hoisted_4),
      _createElementVNode("button", {
        class: "btn btn-danger",
        type: "button",
        onClick: $setup.scanDocument,
        disabled: $setup.isLoadingDocument
      }, _toDisplayString(_ctx.$t('actions.retake')), 9, _hoisted_6),
      _createElementVNode("input", {
        class: "d-none",
        type: "file",
        ref: "documentInput",
        accept: "image/*",
        capture: "environment",
        onChange: $setup.onDocumentScanned
      }, null, 544)
    ])
  ]))
}